import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BaseUiModule } from '@mitsubishi/shared/ui';

import { NgSelectModule } from '@ng-select/ng-select';

import { NewsSelectTagsComponent } from './news-select-tags.component';

@NgModule({
  declarations: [NewsSelectTagsComponent],
  imports: [CommonModule, NgSelectModule, FormsModule, BaseUiModule, CommonModule],
  exports: [NewsSelectTagsComponent],
})
export class NewsSelectTagsModule {}
